import Mock from 'mockjs'
import * as homeAPI from './home'
import * as recruitmentAPI from './recruitment'
import * as gotoAPI from './goto'
import * as qaAPI from './qa'
import * as cultureAPI from './culture'

Mock.setup({
    timeout: '300-600'
})

const BASE_API = 'https://zhaopin.histar.tech'
// const BASE_API = 'http://localhost:8000'

// 首页
Mock.mock(BASE_API + '/cases/GetGroupMembersAll', 'get', homeAPI.getGroupMembers())

// 走进海星
// 简介
Mock.mock(BASE_API + '/enterprise/GetEnterpriseJianjie', 'get', gotoAPI.getJianjie())
// 发展历程
Mock.mock(BASE_API + '/course/GetCourseAll', 'get', gotoAPI.getCourse())
// 公司荣誉
Mock.mock(BASE_API + '/honor/GetHonorAll', 'get', gotoAPI.getHonor())

// 招聘职位
Mock.mock(BASE_API + '/recruitment/GetRecruitmentAll', 'get', recruitmentAPI.getList())

// Q&A
Mock.mock(BASE_API + '/qa/GetQaAll', 'get', qaAPI.getQaList())

// 企业文化
// 工会加
Mock.mock(BASE_API + '/culture/GetGongHuiJia', 'get', cultureAPI.getGongHuiJia())
// 星动壹加
Mock.mock(BASE_API + '/culture/GetXingDongYiJia', 'get', cultureAPI.getXingDongYiJia())
// 海星村
Mock.mock(BASE_API + '/culture/GetHaiXingCun', 'get', cultureAPI.getHaiXingCun())
// 学习与分享
Mock.mock(BASE_API + '/culture/GetXueXiFenXiang', 'get', cultureAPI.getXueXiFenXiang())

export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js